module.exports = __webpack_public_path__ + "static/media/[Professor_Teas]2015-09-15.7646f8c5.md";